import { alpha, InputAdornment, TextField, useColorScheme } from "@mui/material";
import { Constants } from "../../utils/constants";
import SearchOutlinedIcon from '@mui/icons-material/SearchOutlined';


export default function SearchInput({
    label, placeholder, value, onChange, sx
}) {
    const { mode } = useColorScheme();
    return (
        <TextField
            variant="outlined"
            size="small"
            label={label}
            placeholder={placeholder}
            value={value}
            onChange={onChange}
            sx={{
                ...sx,
                '& .MuiOutlinedInput-root': {
                    backgroundColor: alpha(Constants.Colors[mode].input, 0.3),
                    fontSize: "14px",
                },
                // Class for the border around the input field
                "& .MuiOutlinedInput-notchedOutline": {
                    borderColor: Constants.Colors[mode].border,
                },
                "&:hover .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
                    borderColor: Constants.Colors[mode].accent,
                },
                "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
                    borderColor: Constants.Colors[mode].accent,
                },
            }}
            slotProps={{
                input: {
                    startAdornment: (
                        <InputAdornment position="start">
                            <SearchOutlinedIcon sx={{
                                color: Constants.Colors[mode].mutedForeground,
                            }} />
                        </InputAdornment>
                    ),
                },
            }}
        />
    );
}